import { render, staticRenderFns } from "./Head-Title.vue?vue&type=template&id=5cbb875c&scoped=true&"
import script from "./Head-Title.vue?vue&type=script&lang=js&"
export * from "./Head-Title.vue?vue&type=script&lang=js&"
import style0 from "./Head-Title.vue?vue&type=style&index=0&id=5cbb875c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb875c",
  null
  
)

export default component.exports